<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import config from "@/utils/config";
export default {
  name: "app",
  // watch:{
  //   '$route': {
  //     handler (val,oldval) {
  //       setTimeout(() => {

  //         this.move()
  //       }, 5000);
  //     },
  //   }
  // },
  mounted() {
    // this.move();
    // this.xin();
    this.getSystemInfo();
  },
  updated() {
    // this.move();
  },
  methods: {
    // async xin(){
    //   let url = 'http://front.gateway.xinjiang.caetp.cn/studyapp-service/score/getIcaoScore?uuid=31130137394271005111074794122220';
    //   let c = await this.$ajax.get(url);
    //   console.log(c.score,'xxx');
    // },
    async getSystemInfo() {
      let res = await this.TbEnterpriseConfigApi.queryConfig();
      if (res.code == "200") {
        const { systemName, name, logoData } = res.data;
        this.$store.commit("getSystemName", systemName);
        this.$store.commit("getEnterpriseName", name);
        this.$store.commit(
          "getImgUrl",
          config.resourceUrl + JSON.parse(logoData)[1]
        );
        sessionStorage.setItem(
          "iconUrl",
          config.resourceUrl + JSON.parse(logoData)[0]
        );
        sessionStorage.setItem("systemName", systemName);
      }
    },
  },
};
</script>
<style lang="scss">
@import "~normalize.css/normalize.css"; // normalize.css 样式格式化
@import "./styles/index.scss";
// @import './styles/index.scss';
.el-dialog__close {
  color: #cccccc !important;
  margin-top: 5px;
}
.el-dialog__close:hover {
  color: #fff !important;
}
#app {
  width: 100%;
  height: 100%;
  //   overflow-y: scroll;
}
</style>



// WEBPACK FOOTER //
// src/App.vue